export default "__VITE_ASSET__BbO$AdEx__"